import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Hero from "../components/hero/Hero";
import Marquee from "../components/marquee/Marquee";
import About from "../components/about/About";
import Services from "../components/services/Services";
import Projects from "../components/projects/Projects";
import Experience from "../components/experience/Experience";
import Stack from "../components/stack/Stack";
import Contact from "../components/contact/Contact";

const Home = () => {
  const { openPalette } = useOutletContext();

  useEffect(() => {
    document.title = "Yaseen Al-Midani — Full-Stack Software Engineer";
  }, []);

  return (
    <>
      <Hero onOpenPalette={openPalette} />
      <Marquee />
      <About />
      <Services />
      <Projects />
      <Experience />
      <Stack />
      <Contact />
    </>
  );
};

export default Home;
